import {
  AuthenticationContext,
  UserOfficesHandler,
} from "@type/core/auth/auth.types";
import { userOfficesStore } from "@state/offices/OfficesStore";
import { useUnit } from "effector-react";
import { authenticationStore } from "@state/auth/AuthStore";
import { useEffect } from "react";
import {
  setAreOfficesLoading,
  setOffices,
  setSelectedOffices,
} from "@state/offices/OfficesEvents";

export const useOffices = (): UserOfficesHandler => {
  const authStore = useUnit<AuthenticationContext | null>(authenticationStore);
  const userOfficesHandler = useUnit<UserOfficesHandler>(userOfficesStore);

  useEffect(() => {
    setOffices(authStore?.user?.offices ?? []);
    setAreOfficesLoading(false);
  }, [authStore?.user?.offices]);

  useEffect(() => {
    setSelectedOffices(
      userOfficesHandler.offices.filter((o) =>
        authStore?.selectedOfficeIds?.includes(o.id),
      ),
    );
  }, [authStore?.selectedOfficeIds, userOfficesHandler.offices]);

  return {
    areOfficesLoading: userOfficesHandler.areOfficesLoading,
    offices: userOfficesHandler.offices,
    selectedOffices: userOfficesHandler.selectedOffices,
  };
};
